module.exports = "/_next/static/images/cf-2d551ba5ac75475df6bc971fa3e2a99f.svg";